import { Navigate, useLocation } from "react-router-dom";

export default function PersonIndexPage() {
  const location = useLocation();
  return <Navigate to={`${location.pathname}/overview`} replace state={location.state} />;
}
